import { ProductionTypes } from "~/generated/openApi";

/**
 * Basic properties of the application as they are presented on the user
 * interface.
 */
export const appDescriptor = {
    name: "Aker",
};

/**
 * Whether the app is being built in production mode. This is set by
 * Webpack at bundling time. In the absence of a Webpack bundler, this
 * will evaluate to `false`.
 */
export const isInProductionMode = process.env.NODE_ENV === "production";

/**
 * The default locale for Numbro and other locale-aware libraries that we
 * might use.
 */
export const defaultLocale = "en-US";

/**
 * Whether API calls should be made only if we are currently authenticated
 * to the API.
 */
export const loginRequired = true;

/**
 * Waiting time between upload status checks.
 */
export const waitingTimeInMilisecondsBeforeUploadStatusCheck = 1000;

/**
 * Max number of iterations in file upload status check.
 */
export const defaultMaxNumberOfIterationsForFileUploadStatusCheck = 5;

/**
 * Wheter the perspective settings menu button is enabled.
 */
export const isPerspectiveSettingsMenuButtonEnabled = true;

/**
 * Version number for the stored data in the local storage.
 */
export const localStorageVersion = "v1.4.0";

/**
 * WebSocket URL
 */
export const WEBSOCKET_URL: string | undefined = process.env.WEBSOCKET_URL;

/**
 * Socket.IO path (optional)
 */
export const SOCKETIO_PATH: string | undefined = process.env.SOCKETIO_PATH;

/**
 * Filter the perspectives by permissions.
 */
export const ENABLE_PERSPECTIVE_FILTERING_BY_PERMISSIONS = false;

export const productionTypesLabels: Record<ProductionTypes, string> = {
    [ProductionTypes.Unknown]: "unknown",
    [ProductionTypes.Cutting]: "cutting",
    [ProductionTypes.Prefab]: "prefab",
    [ProductionTypes.PreAssembly]: "pre-assembly",
    [ProductionTypes.Assembly]: "assembly",
    [ProductionTypes.Purchasing]: "purchasing",
    [ProductionTypes.Milestone]: "milestone",
    [ProductionTypes.Other]: "other",
    [ProductionTypes.All]: "project",
    [ProductionTypes.PrePrefab]: "pre-prefab",
    [ProductionTypes.PrefabPreAssembly]: "prefab pre-assembly",
    [ProductionTypes.PreAssemblyAssembly]: "pre-assembly assembly",
    [ProductionTypes.PostAssembly]: "post-assembly",
};

export const defaultStationScheduleRowHeight = 60;

export const masterTableId = "mt";

export const projectOverviewTableId = "po";

export const globalDateFormatKey = "<DEFAULT>";

export const defaultDateFormats = [
    globalDateFormatKey,
    "yyyy-MM-dd",
    "dd.MM.yyyy",
    "dd MMM yy",
    "'W'WW dd.MM.yy",
    "'W'WW yyyy",
];

export const defaultEditorDateFormats = ["yyyy-MM-dd", "dd.MM.yyyy", "dd MMM yy"];

export const workbenchStateChangeEvent = "wbStateChange";

export const commitHashPollPeriod = 10000; // in milliseconds (10 seconds)

export const commitHashFileName = "COMMITHASH";

export const flowGraphNodeStrokeWidth = 2;

export const flowGraphShapePreviewWidth = 100;

export const yardMapVerticalAlignAngle = -3.95; // in degrees

export const defaultVPLOptSpeed = 5;
